<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="ml-3">
        <template v-if="isSala">Editar Parceiro</template>
        <template v-else-if="isGov">Editar Projeto</template>

        <template v-else> Editar Município</template>
      </v-btn>
    </template>
    <v-card>
      <v-form
        lazy-validation
        @submit.prevent="onConfirm"
        v-model="valid"
        ref="form"
      >
        <v-card-title class="modal-header elevation-10">
          <v-row>
            <v-col>
              <slot name="title" v-if="isSala">Edição de Parceiro</slot>
              <slot name="title" v-else-if="isGov">Edição de Projeto</slot>
              <slot name="title" v-else>Edição de Município</slot>
            </v-col>
            <v-col class="text-right">
              <v-icon @click="dialog = false" color="white"
                >mdi-window-close</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <h2 v-if="isSala">Sobre o Parceiro</h2>
              <h2 v-else-if="isGov">Sobre o Projeto</h2>

              <h2 v-else>Sobre o Município</h2>
            </v-col>
          </v-row>
          <template
            v-if="
              !isGov &&
              (isFullAdmin ||
                (!config.verSomenteRegional &&
                  !groupsConfig.verSomenteRegional))
            "
          >
            <v-row>
              <v-col>
                <app-project-combobox
                  :filter="payloadLocal"
                ></app-project-combobox>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="file-names">
                <div class="name" v-if="imagemNomeBlob">
                  {{ imagemNomeBlob }}
                </div>
                <v-file-input
                  :label="isSala ? 'Imagem' : 'Imagem do Municipio'"
                  v-model="imagemMunicipio"
                  accept="image/*"
                  prepend-icon="mdi-camera"
                  :rules="rulesPhoto"
                  clearable
                  @change="valueChange('imagemNomeBlob')"
                >
                </v-file-input>
                <span class="ml-8">Imagem até 150kb</span>
              </v-col>
            </v-row>
          </template>
          <v-row>
            <template
              v-if="
                !isGov &&
                (isFullAdmin ||
                  (!config.verSomenteRegional &&
                    !groupsConfig.verSomenteRegional))
              "
            >
              <v-col md="2" sm="2" lg="2" v-if="!isSala">
                <v-text-field
                  label="Código IBGE"
                  name="CodigoIBGE"
                  type="text"
                  required
                  :readonly="!isFullAdmin"
                  :rules="[(v) => !!v || 'Código IBGE é obrigatório']"
                  v-model="payloadLocal.codigoIBGE"
                ></v-text-field>
              </v-col>
            </template>

            <v-col>
              <v-text-field
                :label="
                  isSala
                    ? 'Nome do parceiro'
                    : isGov
                    ? 'Nome do projeto'
                    : 'Nome do município'
                "
                name="nome"
                type="text"
                required
                :readonly="!isFullAdmin"
                v-model="payloadLocal.nome"
              ></v-text-field>
            </v-col>
            <v-col md="4" sm="4" lg="4" v-if="!isGov">
              <app-ur-combobox :filter="payloadLocal"></app-ur-combobox>
            </v-col>
          </v-row>

          <template
            v-if="
              isFullAdmin ||
              (!config.verSomenteRegional && !groupsConfig.verSomenteRegional)
            "
          >
            <v-row>
              <v-col lg="12" v-if="estado == 'MA'">
                <app-pacote-combobox
                  :filter="payloadLocal"
                ></app-pacote-combobox>
              </v-col>
            </v-row>
            <div>
              <v-row>
                <v-col>
                  <app-status-combobox
                    :filter="payloadLocal"
                    @onChange="changeStatusRelacionamento"
                    :sala="false"
                  ></app-status-combobox>
                </v-col>
                <!-- <v-col
                  v-if="
                    payloadLocal.statusId == statusRelacionamentoEnum.vigente ||
                    payloadLocal.statusId == statusRelacionamentoEnum.encerrado
                  "
                >
                  <v-text-field
                    v-model="payloadLocal.contratoInicio"
                    v-mascara="'##/##/####'"
                    label="Data de Início"
                    placeholder="00/00/0000"
                    :disabled="
                      payloadLocal.statusId ==
                      statusRelacionamentoEnum.encerrado
                    "
                    :rules="
                      payloadLocal.statusId == statusRelacionamentoEnum.vigente
                        ? [obrigatorio, verificarAno]
                        : [verificarAno]
                    "
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="
                    !isGov &&
                    (payloadLocal.statusId ==
                      statusRelacionamentoEnum.vigente ||
                      payloadLocal.statusId ==
                        statusRelacionamentoEnum.encerrado)
                  "
                >
                  <v-text-field
                    v-model="payloadLocal.contratoFim"
                    v-mascara="'##/##/####'"
                    :disabled="
                      payloadLocal.statusId == statusRelacionamentoEnum.vigente
                    "
                    label="Data de Término"
                    placeholder="00/00/0000"
                  ></v-text-field>
                </v-col> -->
              </v-row>
              <v-row>
                <!-- <v-col
                  md="3"
                  sm="3"
                  lg="4"
                  v-if="
                    !isGov &&
                    payloadLocal.statusId == statusRelacionamentoEnum.vigente
                  "
                >
                  <app-subsidio-combobox
                    :filter="payloadLocal"
                  ></app-subsidio-combobox>
                </v-col> -->

                <!-- <v-col
                  md="3"
                  sm="3"
                  lg="4"
                  v-if="$store.state.uf === 'RJ' && !isAT && !isSala"
                >
                  <app-status-contrato-combobox
                    :filter="payloadLocal"
                  ></app-status-contrato-combobox>
                </v-col> -->
                <v-col v-if="isFullAdmin || editarMunicipioVerEixos">
                  <app-eixo-combobox
                    :nome="isSala ? 'Pilar' : 'Eixos'"
                    :filter="payloadLocal"
                    ref="eixo"
                    :statusRelacionamento="payloadLocal.statusId"
                    :isCidadeEmpreendedora="payloadLocal.statusContratoId"
                    @eixoChange="trocaEixo"
                  ></app-eixo-combobox>
                </v-col>

                <v-col
                  v-if="
                    !isGov &&
                    (isFullAdmin ||
                      (config.respondePerguntaEixoMunicipio &&
                        groupsConfig.respondePerguntaEixoMunicipio))
                  "
                >
                  <div class="mb-2">
                    <strong
                      >Já realiza ações do portfólio do eixo (local ou
                      nacional)?</strong
                    >
                  </div>
                  <div>
                    <v-data-table
                      :headers="headers"
                      :items="eixosNovos"
                      class="elevation-1"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.amor="{ item }">
                        {{
                          eixos.length &&
                          eixos.filter((eixo) => eixo.eixoId == item.eixoId)
                            .length &&
                          eixos.filter((eixo) => eixo.eixoId == item.eixoId)[0]
                            .nome
                        }}
                      </template>
                      <template v-slot:item.opcao="{ item }">
                        <v-radio-group
                          v-model="item.pergunta"
                          row
                          :rules="
                            eixosAntigos.includes(item.eixoId) ? [true] : rules
                          "
                        >
                          <v-radio label="Sim" :value="'Sim'"></v-radio>
                          <v-radio label="Não" :value="'Não'"></v-radio>
                        </v-radio-group>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
                <v-col cols="12" v-if="isGov">
                  <div>
                    <v-data-table
                      :headers="headersSubeixo"
                      :items="temas"
                      class="elevation-1"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.amor="{ item }">
                        {{
                          eixos.length &&
                          eixos.filter((eixo) => eixo.eixoId == item.eixoId)
                            .length &&
                          eixos.filter((eixo) => eixo.eixoId == item.eixoId)[0]
                            .nome
                        }}
                      </template>
                      <template v-slot:item.opcao="{ item }">
                        <div class="mt-2 mb-2">
                          <combobox-temas-by-eixo
                            :filter="item"
                            :label="'Subeixos'"
                            :eixoId="item.eixoId"
                            @temasChange="(e) => (item.temaId = e)"
                          ></combobox-temas-by-eixo>
                        </div>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  !isGov &&
                  (isFullAdmin ||
                    (config.exibirSecretaria && groupsConfig.exibirSecretaria))
                "
              >
                <v-col>
                  <secretaria
                    :municipioId="$route.params.id"
                    ref="refSecretaria"
                  ></secretaria>
                </v-col>
              </v-row>
            </div>

            <div class="maisDados">
              <template v-if="maisdados">
                <v-row>
                  <v-col
                    v-if="
                      isFullAdmin ||
                      (config.editarMunicipioVerResponsavel &&
                        groupsConfig.editarMunicipioVerResponsavel)
                    "
                  >
                    <app-consultores-combobox
                      :filter="payloadLocal"
                    ></app-consultores-combobox>
                  </v-col>

                  <v-col
                    v-if="
                      estado === 'MS' &&
                      (isFullAdmin ||
                        (config.editarMunicipioVerResponsavel &&
                          groupsConfig.editarMunicipioVerResponsavel))
                    "
                  >
                    <app-analistas-combobox
                      :filter="payloadLocal"
                    ></app-analistas-combobox>
                  </v-col>
                  <v-col
                    v-if="
                      isFullAdmin ||
                      (config.editarMunicipioVerAD &&
                        groupsConfig.editarMunicipioVerAD)
                    "
                  >
                    <app-ads-combobox :filter="payloadLocal"></app-ads-combobox>
                  </v-col>
                </v-row>

                <template
                  v-if="
                    isFullAdmin ||
                    (config.editarMunicipioVerPrefeito &&
                      groupsConfig.editarMunicipioVerPrefeito)
                  "
                >
                  <v-row>
                    <v-col md="6" sm="6" lg="6">
                      <v-text-field
                        label="Prefeito"
                        name="prefeito"
                        type="text"
                        required
                        v-model="payloadLocal.prefeito"
                      ></v-text-field>
                    </v-col>

                    <v-col md="6" sm="6" lg="6">
                      <v-text-field
                        label="Partido"
                        name="partido"
                        type="text"
                        required
                        v-model="payloadLocal.partido"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template
                  v-if="
                    isFullAdmin ||
                    (config.editarMunicipioVerDadosSocioeconomicos &&
                      groupsConfig.editarMunicipioVerDadosSocioeconomicos)
                  "
                >
                  <v-row>
                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="População"
                        name="populacao"
                        type="text"
                        required
                        v-model="payloadLocal.populacao"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4" v-if="estado !== 'BA'">
                      <v-text-field
                        label="Orçamento"
                        name="orcamento"
                        type="text"
                        required
                        v-model="payloadLocal.orcamento"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4" v-if="estado === 'BA'">
                      <v-text-field
                        label="ISDEL"
                        name="isdel"
                        type="text"
                        required
                        v-model="payloadLocal.isdel"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="IDH"
                        name="idh"
                        type="text"
                        required
                        v-model="payloadLocal.idh"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="PIB"
                        name="pib"
                        type="text"
                        required
                        v-model="payloadLocal.pib"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Densidade Demográfica"
                        name="densidadeDemografica"
                        type="text"
                        required
                        v-model="payloadLocal.densidadeDemografica"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Renda Média da População"
                        name="rendaMedia"
                        type="text"
                        required
                        v-model="payloadLocal.rendaMedia"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="4" sm="4" lg="4" v-if="estado !== 'BA'">
                      <v-text-field
                        label="Receita"
                        name="receita"
                        type="text"
                        required
                        v-model="payloadLocal.receita"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4" v-if="estado === 'BA'">
                      <v-text-field
                        label="Área KM²"
                        name="area"
                        type="text"
                        required
                        v-model="payloadLocal.area"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4" v-if="estado !== 'BA'">
                      <v-text-field
                        label="Despesa"
                        name="despesa"
                        type="text"
                        required
                        v-model="payloadLocal.despesa"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4" v-if="estado === 'BA'">
                      <v-text-field
                        label="Tempo média abertura de empresas"
                        name="tempomedia"
                        type="text"
                        required
                        v-model="payloadLocal.tempoMedio"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Número de Empresas"
                        name="numeroEmpresas"
                        type="text"
                        required
                        v-model="payloadLocal.numeroEmpresas"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="estado !== 'BA'">
                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="ME e EPP (N°)"
                        name="me"
                        type="text"
                        required
                        v-model="payloadLocal.me"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="MEI (N°)"
                        name="mei"
                        type="text"
                        required
                        v-model="payloadLocal.mei"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="MEI / Total (%)"
                        name="totalMEI"
                        type="text"
                        required
                        v-model="payloadLocal.totalMEI"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="estado !== 'BA'">
                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="IGM"
                        name="igm"
                        type="text"
                        required
                        v-model="payloadLocal.igm"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Link Google Maps"
                        name="linkMaps"
                        type="text"
                        v-model="payloadLocal.linkMaps"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Número do Contrato"
                        required
                        type="number"
                        :maxlength="100"
                        v-model="payloadLocal.numeroContrato"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="estado === 'BA'">
                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="IDEB"
                        name="ideb"
                        type="text"
                        required
                        v-model="payloadLocal.ideb"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Nº Docentes Educação Infantil"
                        name="docentesEF"
                        type="text"
                        required
                        v-model="payloadLocal.docentesEF"
                      ></v-text-field>
                    </v-col>

                    <v-col md="4" sm="4" lg="4">
                      <v-text-field
                        label="Nº Alunos Educação Infantil"
                        name="alunosEF"
                        type="text"
                        required
                        v-model="payloadLocal.alunosEF"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>

                <v-row v-if="isAT">
                  <v-col>
                    <v-textarea
                      label="Descrição"
                      required
                      :maxlength="5000"
                      v-model="payloadLocal.descricao"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <template
                  v-if="
                    isFullAdmin ||
                    (config.verFaixaIdMunicipio &&
                      groupsConfig.verFaixaIdMunicipio)
                  "
                >
                  <v-row>
                    <v-col>
                      <ComboboxFaixa :faixa="payloadLocal"></ComboboxFaixa>
                    </v-col>
                  </v-row>
                </template>

                <template
                  v-if="
                    isFullAdmin ||
                    (config.editarMunicipioVerAtividadeEconomica &&
                      groupsConfig.editarMunicipioVerAtividadeEconomica)
                  "
                >
                  <v-row>
                    <v-col>
                      <v-divider></v-divider>
                      <h2>Atividades Econômicas</h2>
                      <h4>
                        Selecione as opções que melhor representam as atividades
                        econômicas do município
                      </h4>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      md="2"
                      sm="2"
                      lg="2"
                      v-for="activity in activities"
                      v-bind:key="activity.atividadeId"
                    >
                      <v-row>
                        <v-col>
                          <v-checkbox
                            v-model="payloadLocal.arrAtividades"
                            :id="'atividade' + activity.atividadeId"
                            :label="activity.nome"
                            :item-text="activity.nome"
                            :item-name="activity.atividadeId"
                            :value="activity"
                            color="primary"
                            :return-object="true"
                          >
                          </v-checkbox>
                        </v-col>
                        <v-col class="text-center">
                          <v-icon color="primary" x-large>
                            {{ activity.icone }}
                          </v-icon>
                          <v-text-field
                            label="Percentual"
                            :id="'percentual' + activity.atividadeId"
                            type="text"
                            v-model="activity.percentual"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </template>
            </div>
          </template>
        </v-card-text>
        <template>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
              color="info"
              outlined
              text
              @click="maisdados = !maisdados"
              v-if="!isGov && possuiDadosComplementares()"
              >{{ maisdados ? "Fechar " : "" }}Dados Complementares</v-btn
            >
            <v-btn color="error" outlined text @click="dialog = false">
              Fechar
            </v-btn>

            <template>
              <!-- <v-btn
                color="info"
                type="submit"
                v-if="
                  isFullAdmin ||
                  (config.salvarMunicipio &&
                    groupsConfig.salvarMunicipio &&
                    this.payloadLocal.statusId !==
                      this.statusRelacionamentoEnum.vigente) ||
                  (config.salvarMunicipio &&
                    groupsConfig.salvarMunicipio &&
                    this.payloadLocal.statusId ===
                      this.statusRelacionamentoEnum.vigente &&
                    config.salvarMunicipioVigente &&
                    groupsConfig.salvarMunicipioVigente)
                "
              >
                Salvar
              </v-btn> -->

              <v-btn color="info" type="submit"> Salvar </v-btn>
            </template>
          </v-card-actions>
        </template>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import * as _ from "lodash";
import { municipioEixoApi } from "../API/MunicipioEixo";
import { cityAPI } from "@/modules/city";

import { activityAPI } from "./ActivityAPI";
import { mapActions, mapGetters } from "vuex";
import { AppProjectCombobox } from "@/modules/project";
import { AppUrCombobox } from "@/modules/ur";
import {
  AppConsultoresCombobox,
  AppAdsCombobox,
  AppAnalistasCombobox,
} from "@/modules/user";
import AppStatusCombobox from "./ComboboxStatusRelacionamento";
import AppSubsidioCombobox from "./ComboboxSubsidio.vue";
import AppStatusContratoCombobox from "./ComboboxStatusContrato.vue";
import AppEixoCombobox from "./ComboboxEixo.vue";
import AppPacoteCombobox from "./ComboboxPacotes.vue";
import { eixoAPI } from "../API/eixoAPI";
import { municipioTemasApi } from "@/apis";
import moment from "moment";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
} from "@/types";
import Secretaria from "./secretaria/secretaria.vue";
import { requiredArray } from "@/helpers/validator";
import ComboboxTemasByEixo from "./ComboboxTemasByEixo.vue";
import Swal from "sweetalert2";
import ComboboxFaixa from "../../faixas/components/ComboboxFaixa.vue";

export default {
  name: "AppModalEditCity",
  props: {
    payload: { type: Object },
    edit: { type: Boolean },
  },
  components: {
    AppProjectCombobox,
    AppConsultoresCombobox,
    AppAdsCombobox,
    AppAnalistasCombobox,
    AppUrCombobox,
    AppStatusCombobox,
    AppSubsidioCombobox,
    AppStatusContratoCombobox,
    AppEixoCombobox,
    AppPacoteCombobox,
    Secretaria,
    ComboboxTemasByEixo,
    ComboboxFaixa,
  },
  data() {
    return {
      maisdados: false,
      dialog: false,
      activities: [],
      payloadLocal: this.payload,
      estado: this.$store.state.uf,
      subsidio: [],
      requiredArray: requiredArray,
      temas: [],
      eixosEscolhidos: [],
      headersSubeixo: [
        {
          text: "Eixo",
          value: "amor",
        },
        { text: "Subeixo", value: "opcao" },
      ],
      headers: [
        {
          text: "Eixo",
          value: "amor",
        },
        { text: "Resposta", value: "opcao" },
      ],
      valid: true,
      obrigatorio: (v) => {
        if (!v) return "Campo Obrigatório";

        return true;
      },
      verificarAno: (v) => {
        if (!v) return "Campo Obrigatório";
        const a = v;
        const yearsToday = moment().year();

        const years = moment(a, "DD/MM/YYYY").year();

        if (yearsToday > years && this.teste.contratoInicio != v) {
          return "O ano não pode ser menor que o atual.";
        }

        return true;
      },
      rules: [
        (v) => {
          if (!v) {
            return "Campo Obrigatório";
          }
          if (v == false) {
            return "Campo Obrigatório";
          }
          if (v == "Sem Resposta") {
            return "Campo Obrigatório";
          }

          return true;
        },
      ],
      rulesPhoto: [
        (v) => {
          if (v) {
            if (v.size > 150000) {
              return "Foto maior que 150kb";
            }
          } else {
            return true;
          }
          return true;
        },
      ],
      submited: false,
      user: JSON.parse(localStorage.getItem("user")),
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      imagemMunicipio: null,
      imagemNomeBlob: this.payload.imagemMunicipioNome,
      eixosAntigos: [],
      municipiosTemas: [],
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      eixos: [],
      municipiosEixos: [],
      teste: this.payload,
      eixosNovos: [],
    };
  },
  computed: {
    ...mapGetters([
      "loading",
      "isNA",
      "isAT",
      "isSala",
      "isFullAdmin",
      "isGov",
    ]),
    editarMunicipioVerResponsavel() {
      return (
        this.config.editarMunicipioVerResponsavel &&
        this.groupsConfig.editarMunicipioVerResponsavel
      );
    },
    editarMunicipioVerEixos() {
      return (
        this.config.editarMunicipioVerEixos &&
        this.groupsConfig.editarMunicipioVerEixos
      );
    },
    editarMunicipioVerAD() {
      return (
        this.config.editarMunicipioVerAD &&
        this.groupsConfig.editarMunicipioVerAD
      );
    },
    editarMunicipioVerPrefeito() {
      return (
        this.config.editarMunicipioVerPrefeito &&
        this.groupsConfig.editarMunicipioVerPrefeito
      );
    },
    editarMunicipioVerDadosSocioeconomicos() {
      return (
        this.config.editarMunicipioVerDadosSocioeconomicos &&
        this.groupsConfig.editarMunicipioVerDadosSocioeconomicos
      );
    },
    verFaixaIdMunicipio() {
      return (
        this.config.verFaixaIdMunicipio && this.groupsConfig.verFaixaIdMunicipio
      );
    },
  },

  mounted() {
    this.loadEixos();
    this.loadActivities();
    this.loadMunicipiosEixos();
    this.loadMunicipiosTemas();
  },
  methods: {
    ...mapActions(["setLoading"]),
    trocaEixo(eixos) {
      if (this.isGov) {
        const municipioEixos = eixos.map((item) => {
          let filtro = this.temas.filter((t) => t.eixoId == item.eixoId);

          if (filtro.length) filtro = filtro[0].temaId;
          return {
            ...item,
            temaId: filtro || [],
          };
        });

        this.temas = municipioEixos;
      }

      const val = eixos
        .map((item) => {
          let eixoAntigo = this.eixosNovos.find(
            (val) => val.eixoId == item.eixoId
          );

          if (eixoAntigo) {
            return eixoAntigo;
          }
          return item;
        })
        .sort(function (a, b) {
          return a.eixoId - b.eixoId;
        });

      this.eixosNovos = val;
    },
    possuiDadosComplementares() {
      if (this.isFullAdmin) return true;
      if (this.isAT) return true;

      if (
        !this.editarMunicipioVerResponsavel &&
        !this.editarMunicipioVerAD &&
        !this.editarMunicipioVerPrefeito &&
        !this.editarMunicipioVerDadosSocioeconomicos &&
        !this.verFaixaIdMunicipio
      )
        return false;

      return true;
    },
    changeStatusRelacionamento(event) {
      if (
        (event === this.statusRelacionamentoEnum.encerrado ||
          (this.isSala &&
            event === this.statusRelacionamentoSeloEnum.naoParticipante)) &&
        !this.payloadLocal.contratoFim
      ) {
        this.payloadLocal.contratoFim = moment().format("DD/MM/YYYY");
      } else if (
        event !== this.statusRelacionamentoEnum.encerrado ||
        (this.isSala &&
          event !== this.statusRelacionamentoSeloEnum.naoParticipante)
      ) {
        this.payloadLocal.contratoFim = null;
      }
    },
    async onConfirm() {
      let eixoValid = true;

      this.payloadLocal.contratoInicio = null;

      this.payloadLocal.contratoFim = null;
      this.setLoading(true);
      this.payloadLocal.atividades = [];

      for (let i = 0; i < this.payloadLocal.arrAtividades.length; i++) {
        this.payloadLocal.atividades.push({
          AtividadeId: this.payloadLocal.arrAtividades[i].atividadeId,
          Percentual: this.payloadLocal.arrAtividades[i].percentual,
        });
      }

      this.payloadLocal.arrAtividades = [];
      this.payloadLocal.usuarioId = this.user.usuarioId;
      let contratoFim = moment().format("YYYY-MM-DD HH:mm:ss");

      if (this.payloadLocal.contratoFim) {
        contratoFim = this.payloadLocal.contratoFim;
      }

      if (
        this.payloadLocal.statusId != this.statusRelacionamentoEnum.encerrado
      ) {
        this.payloadLocal.contratoFim = null;
        contratoFim = null;
      }
      const salvar = {
        ...this.payloadLocal,
        contratoFim: contratoFim,
      };

      let formData = new FormData();
      formData.append("municipioId", this.payloadLocal.municipioId);
      formData.append("imagemMunicipio", this.imagemMunicipio);

      if (
        !this.isAT &&
        !this.config.verSomenteRegional &&
        !this.groupsConfig.verSomenteRegional &&
        (this.isFullAdmin || this.editarMunicipioVerEixos)
      ) {
        eixoValid = this.$refs.eixo.validate();
      }

      if (salvar.id_unidade_regional === undefined) {
        salvar.id_unidade_regional = 1;
      }

      if (
        (this.config.verSomenteRegional &&
          this.groupsConfig.verSomenteRegional) ||
        !this.editarMunicipioVerEixos
      ) {
        this.setLoading(true);
        cityAPI
          .update(salvar)
          .then((resp) => {
            this.dialog = false;
            this.imagemMunicipio &&
              cityAPI.updateImageMunicipio(formData).then((val) => {});
            this.$notification.success("Município atualizado com sucesso");
            this.$emit("save");
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar município");
          });
        return;
      }

      if (this.$refs.form.validate() && eixoValid) {
        if (this.isGov) {
          const validacao = this.temas.filter(
            (item) => !item.temaId || (item.temaId && item.temaId.length == 0)
          );

          if (validacao.length > 0) {
            Swal.fire({
              title: "Atenção!",
              text: `É necessário adicionar pelo menos 1 subeixo para cada eixo escolhido.`,
              confirmButtonText: "Ok",
            });

            return;
          }
        }

        cityAPI
          .update(salvar)
          .then((resp) => {
            if (
              !this.isGov &&
              (this.isFullAdmin ||
                (this.config.exibirSecretaria &&
                  this.groupsConfig.exibirSecretaria))
            ) {
              this.$refs.refSecretaria.salvarTodas();
            }

            this.imagemMunicipio &&
              cityAPI.updateImageMunicipio(formData).then((val) => {});
            // if (this.payloadLocal.statusId === 4)
            {
              let municipiosEixosPayload = [];

              if (!this.isAT) {
                if (this.isGov) {
                  this.temas.forEach((element) => {
                    municipiosEixosPayload.push({
                      eixoId: element.eixoId,
                      municipioId: this.payloadLocal.municipioId,
                      usuarioId: this.user.usuarioId,
                      uf: this.$store.state.uf,
                      pergunta: element.pergunta,
                      temaId: element.temaId,
                    });
                  });
                } else {
                  this.eixosNovos.forEach((element) => {
                    municipiosEixosPayload.push({
                      eixoId: element.eixoId,
                      municipioId: this.payloadLocal.municipioId,
                      usuarioId: this.user.usuarioId,
                      uf: this.$store.state.uf,
                      pergunta: element.pergunta,
                      temaId: element.temaId,
                    });
                  });
                }

                municipioEixoApi.create(municipiosEixosPayload).then(() => {
                  this.dialog = false;
                  this.$notification.success(
                    "Município atualizado com sucesso"
                  );
                  this.loadMunicipiosEixos();
                  this.loadMunicipiosTemas();
                  this.$emit("save");
                });
              } else {
                this.dialog = false;
                this.$notification.success("Município atualizado com sucesso");
                this.$emit("save");
              }
            } // else {
            //  this.dialog = false
            //  this.$notification.success('Município atualizado com sucesso')
            //  this.$emit('save')
            // }
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar município");
          });
      }
    },
    valueChange(e) {
      this[e] = null;
    },
    loadActivities() {
      activityAPI
        .list()
        .then((resp) => {
          this.activities = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao listar atividades");
        });
    },
    fillActivities() {
      this.payloadLocal.arrAtividades = [];
      for (var i = 0; i < this.payloadLocal.atividades.length; i++) {
        for (var count = 0; count < this.activities.length; count++) {
          if (
            this.activities[count].nome ===
            this.payloadLocal.atividades[i].atividade.nome
          ) {
            this.activities[count].percentual =
              this.payloadLocal.atividades[i].percentual;
            this.payloadLocal.arrAtividades.push(this.activities[count]);
          }
        }
      }
    },
    loadEixos() {
      eixoAPI
        .list()
        .then((resp) => {
          this.eixos = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Eixos");
        });
    },

    loadMunicipiosEixos() {
      this.setLoading(true);
      municipioEixoApi
        .list()
        .then((resp) => {
          if (resp.data.length) {
            this.municipiosEixos = resp.data.filter(
              (item) =>
                parseInt(item.municipioId) === parseInt(this.$route.params.id)
            );
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar municipiosEixos");
        });
    },
    loadMunicipiosTemas() {
      this.setLoading(true);
      municipioTemasApi
        .listTemaByMunicipio(this.$route.params.id)
        .then((resp) => {
          if (resp.data.length) {
            this.municipiosTemas = resp.data;
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar municipiosTemas");
        });
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        const municipioEixos = this.municipiosEixos
          .map((item) => ({
            ...item,
            temaId:
              (this.municipiosTemas &&
                this.municipiosTemas
                  .filter((t) => t.eixoId == item.eixoId)
                  .map((te) => te.temaId)) ||
              [],
          }))
          .sort(function (a, b) {
            return a.eixoId - b.eixoId;
          });

        this.payloadLocal.eixoId = municipioEixos;
        this.eixosEscolhidos = municipioEixos;

        this.eixosNovos = municipioEixos;

        this.temas = municipioEixos;
        this.$forceUpdate();

        this.eixosAntigos = this.municipiosEixos.map((item) => item.eixoId);
      }
    },
    payload: function (old, newValue) {
      if (old.contratoInicio)
        old.contratoInicio = moment(old.contratoInicio).format("DD/MM/YYYY");
      if (old.contratoFim) {
        old.contratoFim = moment(old.contratoFim).format("DD/MM/YYYY");
      }

      const municipioEixos = this.municipiosEixos
        .map((item) => ({
          ...item,
          temaId:
            (this.municipiosTemas &&
              this.municipiosTemas
                .filter((t) => t.eixoId == item.eixoId)
                .map((te) => te.temaId)) ||
            [],
        }))
        .sort(function (a, b) {
          return a.eixoId - b.eixoId;
        });

      // this.payloadLocal = _.cloneDeep(old);
      this.payloadLocal = old;
      this.payloadLocal.eixoId = municipioEixos;
      this.eixosEscolhidos = municipioEixos;

      this.eixosNovos = municipioEixos;
      this.temas = municipioEixos;

      this.imagemNomeBlob = this.payloadLocal.imagemMunicipioNome;
      this.teste = { ...old };
      this.$forceUpdate();

      this.fillActivities();
    },
  },
};
</script>
<style scoped>
.file-names {
  position: relative;
}

.name {
  position: absolute;
  bottom: 57px;
  left: 45px;
  /* color: #000; */
  width: 62%;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  background: #fff;
  z-index: 1;
}
</style>
<style>
.v-file-input__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
